<div class="billto-container" *ngIf="!selectedBillTo">
  <div class="billto-header">
    <div class="search-bar">
      <i class="fa fa-search"></i>
      <input
        type="text"
        placeholder="Search by Bill To ID or Company Name..."
        [(ngModel)]="searchText"
        (ngModelChange)="filterBillTos()"
        class="search-input"
        aria-label="Search bill to records"
      />
    </div>
    <div class="filter-options">
      <label class="show-inactive-label">
        <p-checkbox
          [(ngModel)]="showInactive"
          (ngModelChange)="filterBillTos()"
          binary="true"
          ariaLabel="Show inactive"
        ></p-checkbox>
        <span>Show Inactive</span>
      </label>
    </div>
  </div>

  <div class="billto-list" *ngIf="filteredBillTos.length > 0">
    <div class="billto-card" *ngFor="let billTo of filteredBillTos" (click)="selectBillTo(billTo)">
      <div class="billto-info">
        <h4 class="billto-name">{{ billTo.companyName }}</h4>
        <p class="billto-id">{{ billTo.customerNo }}</p>
      </div>
      <div class="billto-status">
        <span
          class="status-badge"
          [ngClass]="isBillToActive(billTo) ? 'status-active' : 'status-inactive'"
        >
          {{ isBillToActive(billTo) ? "Active" : "Inactive" }}
        </span>
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>

  <div class="no-billtos" *ngIf="filteredBillTos.length === 0">
    <i class="fa fa-building-o"></i>
    <p>No Bill To locations found</p>
  </div>

  <div class="add-billto-container" *ngIf="isEditMode">
    <button class="btn btn-primary" (click)="addBillTo()">
      <i class="fa fa-plus"></i> Add Bill To
    </button>
  </div>
</div>

<!-- Bill To Detail View -->
<div class="billto-detail" *ngIf="selectedBillTo">
  <div class="detail-header">
    <button class="btn btn-secondary back-button" (click)="backToList()">
      <i class="fa fa-arrow-left"></i> Back to List
    </button>
    <h3 class="detail-title">{{ selectedBillTo.companyName || "New Bill To" }}</h3>
    <span
      class="status-badge"
      [ngClass]="isBillToActive(selectedBillTo) ? 'status-active' : 'status-inactive'"
    >
      {{ isBillToActive(selectedBillTo) ? "Active" : "Inactive" }}
    </span>
  </div>

  <!-- Bill To Tabs -->
  <ul class="nav nav-tabs billto-tabs">
    <li class="nav-item" [class.active]="selectedBillToTab === 'profile'" *ngIf="canViewProfileTab">
      <a class="nav-link" (click)="selectBillToTab('profile')">Profile</a>
    </li>
    <li class="nav-item" [class.active]="selectedBillToTab === 'billing'" *ngIf="canViewBillingTab">
      <a class="nav-link" (click)="selectBillToTab('billing')">Rates</a>
    </li>
  </ul>

  <div class="billto-tab-content">
    <!-- Profile Tab -->
    <div *ngIf="selectedBillToTab === 'profile'" class="tab-pane">
      <div class="profile-row">
        <div class="profile-left">
          <div class="form-horizontal">
            <div class="form-row">
              <label>Name *</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.companyName"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to name"
              />
            </div>

            <div class="form-row">
              <label>Bill To ID *</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.customerNo"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to ID"
              />
            </div>

            <div class="form-row">
              <label>Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="selectedBillTo.email"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to email"
              />
            </div>

            <div class="form-row">
              <label>Phone</label>
              <input
                type="text"
                class="form-control"
                [inputMask]="phoneMask"
                placeholder="(XXX) XXX-XXXX"
                [(ngModel)]="selectedBillTo.phone"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to phone"
              />
            </div>

            <div class="form-row">
              <label>Alt Phone</label>
              <input
                type="text"
                class="form-control"
                [inputMask]="phoneMask"
                placeholder="(XXX) XXX-XXXX"
                [(ngModel)]="selectedBillTo.altPhone"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to alt phone"
              />
            </div>

            <div class="form-row">
              <label>Address *</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.address"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to address"
              />
            </div>

            <div class="form-row">
              <label>City *</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.city"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to city"
              />
            </div>

            <div class="form-row">
              <label>State *</label>
              <select
                class="form-control"
                [(ngModel)]="selectedBillTo.state"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to state"
              >
                <option value="">--Select State--</option>
                <option *ngFor="let state of states" [value]="state.abbreviation">
                  {{ state.fullName }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label>Zip *</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.zip"
                [disabled]="!isEditMode || !canEditProfileTab"
                [inputMask]="zipMask"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to zip code"
              />
            </div>

            <div class="form-row">
              <label>Dispatcher</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedBillTo.dispatcher"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Dispatcher"
              />
            </div>

            <div class="form-row">
              <label>Valid From *</label>
              <input
                type="text"
                class="form-control"
                [inputMask]="dateInputMask"
                placeholder="MM/DD/YY"
                [(ngModel)]="selectedBillTo.validFrom"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to valid from date"
              />
            </div>

            <div class="form-row">
              <label>Valid To</label>
              <input
                type="text"
                class="form-control"
                [inputMask]="dateInputMask"
                placeholder="MM/DD/YY"
                [(ngModel)]="selectedBillTo.validTo"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Bill to valid to date"
              />
            </div>
          </div>
        </div>

        <div class="profile-right">
          <div class="form-horizontal">
            <div class="form-row">
              <label>Invoice Content *</label>
              <select
                class="form-control"
                [(ngModel)]="selectedBillTo.invoiceContent"
                [disabled]="!isEditMode || !canEditProfileTab"
                (ngModelChange)="onBillToChange()"
                aria-label="Invoice content"
              >
                <option value="">--Select--</option>
                <option value="INVOICE ONLY">Invoice Only</option>
                <option value="INVOICE AND BACKUP">Invoice and Backup</option>
              </select>
            </div>

            <div class="form-row checkbox-row">
              <label>Email BOL</label>
              <div class="checkbox-with-tooltip">
                <p-checkbox
                  [(ngModel)]="selectedBillTo.includeBolInEmail"
                  [disabled]="!isEditMode || !canEditProfileTab"
                  (ngModelChange)="onBillToChange()"
                  binary="true"
                  ariaLabel="Email BOL"
                ></p-checkbox>
                <i
                  class="fa fa-question-circle"
                  pTooltip="Include the BOL number in the subject line of the email"
                ></i>
              </div>
            </div>

            <div class="form-row checkbox-row">
              <label>Include BOL in Invoice</label>
              <div class="checkbox-with-tooltip">
                <p-checkbox
                  [(ngModel)]="selectedBillTo.includeBolInInvoice"
                  [disabled]="!isEditMode || !canEditProfileTab"
                  (ngModelChange)="onBillToChange()"
                  binary="true"
                  ariaLabel="Include BOL in invoice"
                ></p-checkbox>
                <i
                  class="fa fa-question-circle"
                  pTooltip="Include the BOL number in the invoice PDF name"
                ></i>
              </div>
            </div>
          </div>

          <div class="invoice-emails-section">
            <h4>Invoice Emails *</h4>
            <div class="emails-list">
              <div
                *ngFor="let email of invoiceEmails; let i = index; trackBy: trackByIndex"
                class="email-row"
              >
                <input
                  type="email"
                  class="form-control"
                  [(ngModel)]="invoiceEmails[i]"
                  [disabled]="!isEditMode || !canEditProfileTab"
                  (ngModelChange)="onInvoiceEmailChange()"
                  placeholder="email@example.com"
                  aria-label="Invoice email address"
                />
                <button
                  *ngIf="isEditMode && canEditProfileTab"
                  class="btn btn-sm"
                  (click)="removeInvoiceEmail(i)"
                  [disabled]="invoiceEmails.length === 1"
                >
                  <i class="fa fa-minus"></i>
                </button>
              </div>
              <button
                *ngIf="isEditMode && canEditProfileTab"
                class="btn btn-secondary"
                (click)="addInvoiceEmail()"
                style="width: 50px"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Billing Tab -->
    <div *ngIf="selectedBillToTab === 'billing'" class="tab-pane">
      <div class="form-section">
        <h4>Rates</h4>
        <app-edit-rates-table
          [clientId]="selectedBillTo.id"
          [isEditing]="isEditMode && canEditBillingTab"
          [(rates)]="selectedBillTo.rates"
          (ratesChange)="onBillToChange()"
        ></app-edit-rates-table>
      </div>
    </div>
  </div>
</div>
